import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=b4a0a4d2&"
import script from "./Masthead.vue?vue&type=script&lang=js&"
export * from "./Masthead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports